module.exports = __webpack_public_path__ + "static/media/icon_help-bofa.31f18e3c.svg";